import type { FC, JSX } from 'react';

const NotificationsTab: FC = (): JSX.Element => {
  const notifications = [
    { label: 'New Patient Registration', description: 'Get notified when a new patient registers' },
    { label: 'Appointment Reminders', description: 'Receive reminders for upcoming appointments' },
    { label: 'Emergency Calls', description: 'Immediate notification for emergency situations' },
    { label: 'Failed Reminder Deliveries', description: 'Alert when reminders fail to send' },
    { label: 'Daily Summary', description: 'Daily email with clinic statistics' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-6">Notification Settings</h2>

        <div className="space-y-4">
          {notifications.map((notification, index) => (
            <div
              key={notification.label}
              className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50"
            >
              <div>
                <p className="font-medium text-gray-900">{notification.label}</p>
                <p className="text-sm text-gray-600">{notification.description}</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" defaultChecked={index !== 3} className="sr-only peer" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationsTab;
